import axios from '@/utilities/service/httpClient'
import Authentication from '@/utilities/auth/Authentication'
import AxiosService from '@/utilities/service/AxiosService'
import VueJwtDecode from 'vue-jwt-decode'
import { AZURE_KEYS } from '@/plugins/azure'
import TokenManager from '@/utilities/auth/azure/TokenManager'

export default {
  isLoggedIn: state => {
    try {
      const tokenManager = new TokenManager({ apiKey: AZURE_KEYS }, window.localStorage)
      const auth = new Authentication(state.token ? { token: state.token } : tokenManager.getTokens(), VueJwtDecode)

      if (auth.isToken()) {
        const axiosService = new AxiosService(axios, VueJwtDecode)
        axiosService.setAuthorization(auth)
      } else {
        throw new Error('Invalid token')
      }

      return auth.isToken()
    } catch (error) {
      delete axios.defaults.headers.common.Authorization
      return false
    }
  },
  getFirstName: state => {
    return state.user ?? ''
  },
  authStatus: state => state.status,
  getUser: state => state.user,
  userId: state => state.opusPayload?.payload?.id,
  permissions: state => state.opusPayload?.payload?.permissions ?? [],
  role: state => state.opusPayload?.payload?.role,
}
